import { AccountOption, AccountSelectionList, Button } from '@cma/common'
import { UseDifferentEmailButton } from '@cma/features/auth'
import { HelixIcon } from '@helix/helix-icon'
import { diamond_exclamation as ExclamationIcon } from '@helix/helix-icon/solid'
import { useState } from 'react'

interface SelectSsoAccountCardProps {
  accounts: AccountOption[]
  email: string
  onContinue(account: AccountOption): void
  onUseDifferentEmail(): void
}

export function SelectSsoAccountCard({
  accounts,
  email,
  onContinue,
  onUseDifferentEmail
}: SelectSsoAccountCardProps) {
  const [selectedAccount, setSelectedAccount] = useState<AccountOption>()

  return (
    <div className="w-[400px] max-w-full space-y-6">
      <div className="space-y-6 rounded-lg bg-white px-8 py-6 shadow">
        <div className="space-y-2 text-center">
          <h1 className="text-2xl font-medium">Select an account to connect</h1>
          <p className="text-sm text-gray-600">
            We found more than one Cloud CMA account associated with{' '}
            <span className="font-semibold">{email}</span>. Select the account
            you want to sign in with and connect to your Realtor.com account.
          </p>
        </div>
        <div className="helix-bg-yellow-50 helix-text-yellow-900 flex items-start gap-2 px-3 py-2 text-sm">
          <HelixIcon
            icon={ExclamationIcon}
            className="helix-svg-fill--yellow-600 h-5 w-5 shrink-0"
            aria-hidden
          />
          <span>
            The account you select will be used for this Realtor.com connection.
          </span>
        </div>
        <AccountSelectionList
          accounts={accounts}
          value={selectedAccount?.accountId}
          onChange={setSelectedAccount}
        />
        <Button
          type="button"
          fullWidth
          disabled={!selectedAccount}
          onClick={() => selectedAccount && onContinue(selectedAccount)}>
          Continue
        </Button>
      </div>
      <UseDifferentEmailButton onClick={onUseDifferentEmail} />
    </div>
  )
}
